<!-- eslint-disable max-len -->
<template lang="pug">
.container.document-view
  .breadcrumb-voucher.py-3
    nav(aria-label='breadcrumb')
      ol.breadcrumb
        li.breadcrumb-item
          router-link(to='/')
            Icon.color--info(name='house')
        li.breadcrumb-item.active
          router-link.color--primary.disabled.fw-600(to='/') Envio de documentos
  .main.d-flex.flex-column(role='main')
    section.title-section.d-flex.justify-content-between
      div
        h2.fw-600 Envio de documentos
        p Por aqui você pode enviar os documentos que ficaram pendentes para a finalização da sua emissão.
      div
        button.btn.btn-sm.btn-info(@click='exitPage')
          span Sair
          Icon.ms-2(name='right-from-bracket')
    section.row
      .selecions.col-md
        .selection-field.py-4
          p Selecione o tipo de empresa para ver a lista de documentos.
          Selectable(
            name='companySegment',
            icon='building',
            :options='form.types',
            v-model='companySegmentSeleted',
            labelSelectable='nome',
            placeholder='Selecione',
            @Update:modelValue='handleCompanySegmentChange'
          )
        .selection-field.py-4(v-show='!!companySegmentSeleted')
          p Selecione um tipo de {{ selectedCompanySegmentLabel }}
          Selectable(
            :key='companySegmentId',
            name='companySegment',
            icon='building',
            :options='form.documents',
            v-model='companyTypeSelected',
            labelSelectable='nome',
            placeholder='Selecione um tipo de unidade'
          )
        .text-documents-required.col-md(
          :class='[companyTypeSelected !== "" ? "d-flex" : "d-none"]'
        )
          h4.h-x-small.pt-0.ps-0 {{ companyType.nome }}
          hr
          ul
            li.ps-1(v-for='doc in companyType.list')
              span {{ doc }}
          ul.notes-list.p-0(v-if='hasNotes')
            li(v-for='nota in companyType.notas')
              span #[strong Nota:] {{ nota }}
      .upload.py-4.col-md
        Upload.flex-grow-1(
          :is-mobile='isMobile',
          :files-loaded='filesLoaded',
          :extension-types='extentionsAllows',
          @addFile='handleAddFile'
        )
        FilesLoader(
          :files-loaded='filesLoaded',
          :extension-types='extentionsAllows',
          @handleDeleteFile='deleteLoadedFile'
        )
        .d-flex.justify-content-end.py-4(v-if='hasSendFiles')
          button.btn(
            type='button',
            :disabled='isInvalid',
            @click='sendFiles',
            :class='isInvalid ? "btn-secondary disabled" : "btn-primary"'
          )
            span.me-2 Enviar
            Icon(name='arrow-right')
        .mt-5(v-if='sentFiles.length > 0')
          p.m-0.fs-6.fw-bold Abaixo os documentos que você já enviou:
          p.m-0 Caso queira, você pode excluir algum.
        FilesLoader(
          :files-loaded='sentFiles',
          :extension-types='extentionsAllows',
          @handleDeleteFile='deleteSentFile'
        )
  Contact(style='margin-bottom: 6rem')
LoadingVue(:isLoading='isLoading')
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import Wizzard from '@/components/Molecules/Wizzard.vue'
  import Selectable from '@/components/Atoms/Selectable.vue'
  import Upload from '@/components/Molecules/Upload.vue'
  import Camera from '@/components/Molecules/Camera.vue'
  import { typesCompany, documentsList } from '@/store/JSON/documentsJson'
  import mobileAndTabletCheck from '@/utils/browserDeviceCheck'
  import { mapActions, mapState } from 'pinia'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'
  import sentFilesController from '@/infra/sisAr/sentFiles.controller'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'
  import FilesLoader from '@/components/Molecules/FilesLoader.vue'
  import ModalSuccessfullySentVue from '@/components/templates/ModalSuccessfullySent.vue'
  import LoadingVue from '@/components/Atoms/Loading.vue'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useOeRecaptcha } from '@/composables/useOeRecaptcha'

  type DocumentsSegment =
    | 'Sociedade'
    | 'Empresário Individual'
    | 'Das demais Entidades de Direito Privado'
    | 'Das Entidades de Direito Público'

  interface IObjectDocument {
    nome: string
    type: DocumentsSegment
    list: string[]
    notas: string[]
  }

  export default defineComponent({
    name: 'DocumentsUpload',
    components: {
      Icon,
      Wizzard,
      Selectable,
      Contact,
      Camera,
      Upload,
      FilesLoader,
      ModalSuccessfullySentVue,
      LoadingVue,
    },
    setup() {
      return {
        oeRecaptcha: useOeRecaptcha(),
      }
    },
    data: () => ({
      form: {
        types: typesCompany,
        documents: [] as Array<IObjectDocument>,
      },
      companySegmentSeleted: '',
      companySegmentId: 0,
      companyTypeSelected: '',
      companyType: {} as IObjectDocument,
      isMobile: false,
      filesLoaded: [] as Array<File>,
      sentFiles: [] as Array<File>,
      extentionsAllows: ['png', 'jpg', 'jpeg', 'doc', 'docs', 'docx', 'pdf'],
      isLoading: false,
    }),
    watch: {
      companySegmentSeleted(curr: string) {
        this.form.documents = documentsList.filter(
          (x: IObjectDocument) => x.type === curr,
        )
      },
      companyTypeSelected(curr) {
        const company = this.form.documents.find(
          (x: IObjectDocument) => x.nome === curr,
        )
        if (company) {
          this.companyType = company
        }
      },
    },
    computed: {
      ...mapState(useDynamicForms, ['getPassword']),
      ...mapState(useSolicitation, ['getSolicitation']),
      isInvalid() {
        return this.filesLoaded.length === 0 || this.findDocumentError()
      },
      hasNotes() {
        return this.companyType.notas && this.companyType.notas.length > 0
      },
      hasSendFiles() {
        return this.filesLoaded.length > 0
      },
      selectedCompanySegmentLabel() {
        if (
          this.companySegmentSeleted ===
          'Das demais Entidades de Direito Privado'
        ) {
          return 'Entidade de Direito Privado'
        }

        if (this.companySegmentSeleted === 'Das Entidades de Direito Público') {
          return 'Entidade de Direito Público'
        }

        return this.companySegmentSeleted
      },
    },
    methods: {
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      ...mapActions(useModalLoading, ['setIsLoading']),
      handleAddFile(newFiles: File[]) {
        if (this.filesLoaded.length >= 10) {
          return
        }
        if (this.filesLoaded.length > 0) {
          this.filesLoaded = [...this.filesLoaded, ...newFiles]
        } else {
          this.filesLoaded = [...newFiles]
        }
      },
      deleteLoadedFile(indexFile: number) {
        this.filesLoaded.splice(indexFile, 1)
      },
      async deleteSentFile(index: number) {
        this.isLoading = true

        const recaptchaToken = await this.oeRecaptcha.getToken('delfile')

        sentFilesController
          .delete(
            this.getSolicitation.cdSolicitacao,
            this.getPassword,
            this.sentFiles[index].name,
            recaptchaToken,
          )
          .then(() => {
            const filtered = this.sentFiles.filter(
              (x: File, i: number) => i !== index,
            )
            this.sentFiles = filtered

            this.toggleToastGlobal({
              isShow: true,
              type: 'success',
              icon: 'circle-check',
              message: 'Documento excluído com sucesso!',
            })
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      async sendFiles() {
        try {
          this.setIsLoading({
            isLoading: true,
            title: 'Aguarde enquanto enviamos seus documentos',
            message: '',
            image: 'fileUpload',
          })

          await sentFilesController.sendFiles(
            this.filesLoaded,
            this.oeRecaptcha.getToken,
          )

          this.toggleToastGlobal({
            isShow: true,
            type: 'success',
            icon: 'circle-check',
            message: 'Documento enviado com sucesso!',
          })

          await this.getSentFiles()
          this.filesLoaded = []
        } catch (error: any) {
          const backendMessage =
            error?.response?.data?.message ||
            error?.response?.data?.mensagem ||
            error?.message

          this.toggleToastGlobal({
            isShow: true,
            message:
              backendMessage ||
              'Houve um erro ao enviar seus documentos, tente novamente mais tarde',
          })
        } finally {
          this.setIsLoading({ isLoading: false })
        }
      },
      findDocumentError() {
        return !!this.filesLoaded.find(
          (x: File) => !this.extentionsAllows.includes(x.type.split('/')[1]),
        )
      },
      async getSentFiles() {
        const recaptchaToken = await this.oeRecaptcha.getToken('getfiles')

        this.sentFiles = await sentFilesController.list(
          this.getSolicitation.cdSolicitacao,
          this.getPassword,
          recaptchaToken,
        )
      },
      handleCompanySegmentChange() {
        this.companyTypeSelected = ''
        this.companyType = {} as IObjectDocument
        this.companySegmentId += 1
      },
      exitPage() {
        const dynamicFormsStore = useDynamicForms()
        const solicitationStore = useSolicitation()

        solicitationStore.getSolicitation.cdSolicitacao = ''
        dynamicFormsStore.$state.formData.senha = ''

        this.$router.push({ name: 'uploadLogin' })
      },
    },
    async mounted() {
      this.oeRecaptcha.showBadge()

      this.isMobile = mobileAndTabletCheck()
      await this.getSentFiles()
    },
    beforeRouteEnter(to, from, next) {
      const dynamicFormsStore = useDynamicForms()
      const solicitationStore = useSolicitation()

      if (
        solicitationStore.getSolicitation.cdSolicitacao !== '' &&
        dynamicFormsStore.getPassword !== ''
      ) {
        return next()
      } else {
        return next({ name: 'uploadLogin' })
      }
    },
    beforeRouteLeave() {
      this.oeRecaptcha.hideBadge()
    },
  })
</script>

<style lang="stylus" scoped>
  .text-documents-required
    display: flex;
    flex-direction: column
    margin-top: 1rem;
    padding: 1rem;
    border-radius: 15px;
    background-color: var(--color-grayscale-light)
  .document-view
    padding: 1rem
    text-align: left !important;
  .h-x-small
    padding-top: 1rem
    padding-left: 1rem
  .notes-list
    list-style-type: none;
  .main
    position: relative
    margin-top: 2.5rem;
    display: flex;
    margin-bottom: 1rem

  @media screen and (max-width: 768px)
    .main
      flex-direction: column
    .action-section > button
      width: 100%
</style>
